import type { PropsWithChildren } from "react";
import { BrowseLayoutContext } from "#browse-layout-context";
import { useBrowseLayoutContextValue } from "#browse-layout-context-value";

export function BrowseLayoutContextProvider({ children }: PropsWithChildren) {
  const value = useBrowseLayoutContextValue();
  return <BrowseLayoutContext.Provider value={value}>{children}</BrowseLayoutContext.Provider>;
}
